import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CustomerPaymentsOutput, PaywayCustomerRequest } from '../../../models/account-ledger.model';
import { ApiResponse } from '../../../models/api-response.model';
import { CheckOutService } from '../../../services/checkout.service';
import { CommonService } from '../../../services/common.service';
import { ManageService } from '../../../services/manage.service';
import { MyAccountService } from '../../../services/myAccount.service';
import { NgProgressService } from '../../../services/ngProgress.service';
import { ccform, baform } from '../../../shared/JavaScript/paymentform';

@Component({
    selector: "subscription-add-digital-wallet",
    templateUrl: "./add-digital-wallet.component.html",
    styleUrls: ["./add-digital-wallet.component.css"],
})

export class AddDigitalWalletComponent implements OnInit {

    paymentForm: boolean = true;
    paymentGroup: FormGroup;
    paywayCustomer: PaywayCustomerRequest;
    selectedPaymentMethod: string;
    apiKey: string;
    submitClass: string;
    singleToken: string;
    customerPayments: CustomerPaymentsOutput[];

    constructor(
        private commonService: CommonService,
        private checkOutService: CheckOutService,
        private manageService: ManageService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private myAccountService: MyAccountService,
        public ngProgress: NgProgressService
    ) {
        this.paymentGroup = new FormGroup({
            customerName: new FormControl('', [Validators.required]),
            emailAddress: new FormControl(''),
            street1: new FormControl(''),
            street2: new FormControl(''),
            cityName: new FormControl(),
            state: new FormControl(''),
            postalCode: new FormControl(''),
            phoneNumber: new FormControl(''),
            paywayPersonalUse: new FormControl(''),
            maxAuthorisedAmount: new FormControl('')
        });
    }

    ngOnInit() {
        this.myAccountService.GetCurrentPublishableKey().subscribe((key: string) => {
            this.apiKey = key;
        },
            (error: any) => {
                console.error(error);
            });
    }

    closeRightPanel() {
        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }

    isNotValidField(path: string, validateClass: any): void {
        if (this.paymentGroup.get(path).hasError('required')) {
            this.commonService.showValidator(validateClass, 'Please name your payment option', 'right', 'error');
        }
    }

    registerPayment(): void {
        if (this.paymentGroup.valid) {
            this.checkOutService.SetPaywayCustomer(this.paymentGroup.value).subscribe((res: PaywayCustomerRequest | ApiResponse) => {
                if ((res as ApiResponse)?.status == false) {
                    this.commonService.implementToast((res as ApiResponse)?.responseMessage, 'Error')
                } else {
                    this.paywayCustomer = res as PaywayCustomerRequest;
                    this.paymentForm = false;
                    if (this.selectedPaymentMethod === 'creditcard') {
                        this.showCCForm();
                    } else if (this.selectedPaymentMethod === 'bankaccount') {
                        this.showBAForm();
                    }
                }

            },
                (error: any) => {
                    console.error(error);
                });
        } else {
            this.isNotValidField('customerName', '.customerNameValidate');
        }
    }

    showCCForm(): void {
        this.selectedPaymentMethod = 'creditcard';
        $('.cc').attr('disabled', 'disabled');
        $('.ba').removeAttr('disabled');
        setTimeout(() => {
            ccform(this.apiKey);
        }, 100);
    }

    showBAForm(): void {
        this.selectedPaymentMethod = 'bankaccount';
        $('.ba').attr('disabled', 'disabled');
        $('.cc').removeAttr('disabled');
        setTimeout(() => {
            baform(this.apiKey);
        }, 100);
    }

    paywayLanding(type: string): void {
        this.ngProgress.start();
        this.submitClass = type === 'cc' ? 'payway-cc-submit' : 'payway-ba-submit';
        setTimeout(() => {
            this.singleToken = $('#msg').html();
            this.checkOutService.PaywayLanding(this.paywayCustomer, this.singleToken).subscribe((res: ApiResponse) => {
                if (res.status) {
                    this.commonService.implementToast(res.responseMessage, 'Success');

                    this.manageService.updateDigiwalWalletSubject.next(); this.closeRightPanel();

                } else {
                    this.commonService.implementToast(res.responseMessage, 'Error');
                }
            },
                (error: any) => {
                    console.error(error);
                    this.ngProgress.done();
                });
            this.ngProgress.done();
        }, 1500);
    }

    backToForm(): void {
        this.manageService.updateDigiwalWalletSubject.next(); 
        this.paymentForm = true;
    }
}